import React, { useState, useEffect } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import Sidebar from "../../frontend/DesignSystem/Sidebar";
import ApplicationsTable from "../Recruitment/Applications/HelperFunctions/ApplicationSummary";
import EnquiriesList from "../Enquiries/EnquiriesList";
import "../../css/HomeScreen/HomeScreen.css";
import RecruitmentForm from "../Recruitment/Applications/RecruitmentForm";
import FileUpload from "../Accounts/PdfToCsv/FileUpload";
import FileDirectory from "../Compliance/MembersHub/FileDirectory";
import ChatbotScreen from "../Compliance/Chatbot/ChatbotScreen";
import RecruitmentMap from "../Adviser/Components/PostcodeMap/PostcodeMap";


const HomeScreen = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
  };

  return (
    <div className="home-container">
      <Sidebar
        isSidebarVisible={isSidebarVisible}
        toggleSidebar={toggleSidebar}
        isSmallScreen={isSmallScreen}
      />

      <div
        className={`main-content ${
          isSidebarVisible && isSmallScreen ? "blur" : ""
        }`}
      >
        <Routes>
          <Route path="/PostcodeMap" element={<RecruitmentMap />} />
          <Route path="/Applications" element={<ApplicationsTable />} />
          <Route path="/Enquiries" element={<EnquiriesList />} />

          <Route path="/Applications/:uid" element={<RecruitmentForm />} />
          <Route
            path="/Convert Commission Statements"
            element={<FileUpload />}
          />
          {/* <Route path="*" element={<ApplicationsTable />} /> */}
          <Route path="/MembersHub" element={<FileDirectory />} />
          <Route
            path="/MembersHub-Test/:folderName"
            element={<FileDirectory />}
          />
          <Route path="/1-AIN" element={<ChatbotScreen />} />
        </Routes>
      </div>
    </div>
  );
};

export default HomeScreen;
